/**
 * Collect a form's hidden-field context (content_type, content_name,
 * home_design, estate_name, suburb, lead_source, conversion_page, utm_*, …)
 * into a flat map so the form_submit event carries the same dimensions GA4
 * needs — without the listener having to know each field by name. CSRF and
 * honeypot fields are skipped.
 *
 * @param {HTMLFormElement} form
 * @returns {Record<string, string>}
 */
function collectFormContext(form) {
    const ctx = {};
    form.querySelectorAll('input[type="hidden"]').forEach((input) => {
        const name = input.name;
        // Framework/meta fields, not lead dimensions: CSRF, Statamic's params
        // bag, the honeypot, and the form's post-submit redirect targets.
        if (!name || name === 'captcha_token' || name === '_token' || name === '_params' || name === 'winnie' || name === '_redirect' || name === '_error_redirect') return;
        if (input.value) ctx[name] = input.value;
    });
    return ctx;
}

/** Capture attribution before an async submit can navigate or replace fields. */
export function captureFormSubmission(form) {
    if (!form.matches('[data-track-form]')) return null;

    return {
        form_name: form.dataset.trackLabel || form.id || '',
        label: form.dataset.trackLabel || form.id || '',
        action: form.action || '',
        page_path: location.pathname,
        ...collectFormContext(form),
    };
}
